import Api from './Api';

const END_POINT = 'planilla-detalle';
const END_POINT_NEW = 'planilla-cierra';
const END_POINT_ABRE = 'planilla-abre';
const END_POINT_PAGA = 'planilla-pagar';
const END_POINT_BONO = 'planilla-bono';

export default {
    async getEmpleados (id) {
        return await Api.get(`${END_POINT}/${id}`);
    },
    async actualizaEmpleado(descuento) {
        return await Api.patch(`${END_POINT}/${descuento.id}`, descuento)
    },
    async actualizaBonoEmpleado(bono) {
        return await Api.patch(`${END_POINT_BONO}/${bono.id}`, bono)
    },
    async guardaCierra(items) {
        return await Api.post(`${END_POINT}`, items);
    },
    async calculaCierra(items) {
        return await Api.post(`${END_POINT_NEW}`, items);
    },
    async reabrirPlanilla(items) {
        return await Api.post(`${END_POINT_ABRE}`, items);
    },
    async pagarPlanilla(pago) {
        return await Api.post(`${END_POINT_PAGA}`, pago);
    },
    async planillaDownload(id) {
        return await Api.get('planilla/download/'+`${id}`);
    },
    async actualizarPlanilla(id_planilla){
        return await Api.get('planilla/actualizar/' + `${id_planilla}`);
    }
}